import requestInterceptor from './requestInterceptor'
import { responseOnError } from './responseInterceptor'

export default { requestInterceptor, responseOnError }
